
export enum HierarchyItemType {
    HierarchyRoot = 0,
    AssetGroup = 1,
    AssetObject = 2
}

export enum AssetGeometryPendingContext {
    CalculatingProgress = 'calculatingProgress',
    InitializingAssetSets = 'initializingAssetSets',
    InitializingKnowledgeView = 'initializingKnowledgeView',
}

export interface IHierarchyItemDetail extends INamedItem {
    ItemType: HierarchyItemType;
    ItemClassName: string;
    Parents: IHierarchyItemNameDetail[];
    InternalAttributes: IHierarchyItemAttributeValue[];

    // Properties not in model
    AssetID?: string;
}

export interface IHierarchyItemNameDetail extends INamedItem {
    HasAttributes: boolean;
    ItemClassName: string;
}

export interface IHierarchyItemAttributeValue {
    SetDefinitionName: string;
    Name: string;
    Value: string;
    Unit: string;
    IsUrl: boolean;

    // Properties not in model
    IsReadOnly?: boolean;
}

export type ContentLayers = {
    assets: boolean;
    cad: boolean;
    pointCloud: boolean;
    mesh: boolean;
    positions360: boolean;
    scanPositions: boolean;
    colorScanPositions: boolean;
    blackAndWhiteScanPositions: boolean;
    imagePositions: boolean;
    assetTags: boolean;
    assemblies: boolean;
}

export const KNOWLEDGE_VIEW_CONTENT_LAYERS_VERSION = 2;

export const defaultContentLayers: ContentLayers = {
    assets: true,
    cad: true,
    pointCloud: false,
    mesh: true, // smart mesh
    positions360: false,
    scanPositions: true,
    colorScanPositions: true,
    blackAndWhiteScanPositions: true,
    imagePositions: true,
    assetTags: false,
    assemblies:false
} as const

export const facilityMapContentLayers: ContentLayers = {
    ...defaultContentLayers,
    positions360: true,
    scanPositions: true,
    colorScanPositions: true,
    blackAndWhiteScanPositions: true,
    imagePositions: true
};

export const panoContentLayers: ContentLayers = {
    ...facilityMapContentLayers,
    assetTags: true
};
